import ProductBrandLogo from '@/components/Brand/ProductBrandLogo';
import { useAuth } from '@/contexts/AuthContext';
import { ArrowRight, SignOut } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';

const PluginAccessLimitedPage = () => {
    const navigate = useNavigate();
    const { logout } = useAuth();

    return (
        <main className="flex min-h-screen w-full items-center justify-center bg-[#F7F8FA] px-6 py-10">
            <section className="w-full max-w-[560px] text-center">
                <div className="mb-10 flex justify-center">
                    <ProductBrandLogo size="34px" />
                </div>
                <div className="mx-auto mb-7 flex h-14 w-14 items-center justify-center rounded-2xl bg-[#E8F5EF] text-[#146C43]">
                    <ArrowRight size={26} weight="bold" />
                </div>
                <h1 className="text-3xl font-semibold leading-tight text-[#161A23]">
                    BizSidekick is at capacity
                </h1>
                <p className="mx-auto mt-4 max-w-[460px] text-base leading-7 text-[#596273]">
                    We are opening Plugin access gradually. Check back soon, or contact us if you need access for testing now.
                </p>
                <div className="mt-9 flex flex-wrap items-center justify-center gap-3">
                    <button
                        type="button"
                        onClick={() => navigate('/onboarding', { replace: true })}
                        className="inline-flex min-h-11 items-center justify-center rounded-lg bg-[#161A23] px-5 text-sm font-semibold text-white transition-colors hover:bg-[#2A3140]"
                    >
                        Check again
                    </button>
                    <button
                        type="button"
                        onClick={() => logout()}
                        className="inline-flex min-h-11 items-center justify-center gap-2 rounded-lg border border-[#D7DCE5] bg-white px-5 text-sm font-semibold text-[#283142] transition-colors hover:border-[#BFC7D4]"
                    >
                        <SignOut size={16} weight="bold" />
                        Sign out
                    </button>
                </div>
            </section>
        </main>
    );
};

export default PluginAccessLimitedPage;
